import * as React from 'react';

export interface WebPushContextType {
  supported: boolean;
  enabled: boolean;
  blocked: boolean;
  dismissed: boolean;
  enable: () => void;
  revoke: () => void;
  dismiss: () => void;
}

const WebPushContext = React.createContext<WebPushContextType>({
  supported: false,
  enabled: false,
  blocked: false,
  dismissed: false,
  enable: () => {},
  revoke: () => {},
  dismiss: () => {},
});

export default WebPushContext;
